module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPf394SEhGBNHFNLG1NEG1JGDURBG0hAFT45Ev8CAP8AADc5CzAvEigvCiEkEQghCBccCQgZCDoAADEAAAgICCEAABkAABAAAAAAAP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABkALAAAAAAgACAAAAW0YCaOZGmeaKqubOu+cCzPcxDQq+1ifO//QOAIgFEYjxHMpNKTTCy9ozSDERWlSUVkGzFyu4qD1GilYqPjMQMDGY94Z3ha6sAg5tqrF41XDHh3aVlIGFB9Rn92c4N7F3p4BjwCi49Jcn0NkpRxj3MIgJtITJ1pBRgMeIxGBJepGGBHb69YXREQDKgKDQsMYA9pIhRWsHs9Wz0TEMSxwiRflkE+z8c4Ojgn1tfa29zd3t/g4RkhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadE_S6.gif
// module id = 5I/H
// module chunks = 48